export const ROLE_LABEL = {
  admin: "Administrador",
  master: "Master Franchising",
  agency_manager: "Broker / Team Leader",
  coach: "Coach",
  consultant: "Consultor",
  staff: "Staff",
};

// External self-assessment tools
export const MBTI_TEST_URL = "https://www.16personalities.com/pt/teste-de-personalidade";
export const VIA_TEST_URL = "https://www.viacharacter.org/account/register";

export const MEMBER_ROLES = ["consultant", "staff", "agency_manager"];

export const PERSONAL_IDEAL_HELP =
  "O Ideal Pessoal é a interseção do teu Ideal de Missão com o teu Ideal de Personalidade — a ideia predileta que Deus tem para ti enquanto membro da agência.";
